<div class="w-100 h-100 d-flex flex-column">
  <app-reservation-filter [initialState]="initialFilterState" (onFilterChange)="filterChanged($event)" />
  <app-api-paginated-grid
    class="flex-fill"
    [listOperator]="listReservationsOperator"
    [createOperator]="createReservationOperator"
    [updateOperator]="updateReservationOperator"
    [columnDefs]="columnDefs" />
</div>
